import angular from 'angular';
import _ from 'lodash';

angular.module('application').factory('alertDialog', ["$rootScope", "$mdDialog", function($rootScope, $mdDialog) {
    alertDialogController.$inject = ["$scope", "$mdDialog", "message", "confirmLabel", "showConfirmButton", "isKioskShowed", "userSessionsManager", "$state"];

    function alertDialogController($scope, $mdDialog, message, confirmLabel, showConfirmButton, isKioskShowed, userSessionsManager, $state) {
        $scope.message = message;
        $scope.confirmLabel = confirmLabel;
        $scope.showConfirmButton = showConfirmButton;
        $scope.isKioskShowed = isKioskShowed;

        $scope.answer = function() {
            $mdDialog.hide();
        };

        $scope.exit = async () => {
            const user = await userSessionsManager.show({ disableNewUser: true, canDismiss: true, selectActiveUser: true });
    
            if(user) {
                $mdDialog.cancel().finally(function() {
                    $state.go('app.new.cashregister');
                });
            }
        };
    
    }

    var alertDialog = {
        show: function(message, options) {
            $rootScope.hideAppLoader();

            var defaultOptions = {
                controller: alertDialogController,
                template: require('./alert-dialog.html'),
                locals: {
                    message: message,
                    confirmLabel: _.get(options, "confirmLabel") || "OK",
                    showConfirmButton: _.get(options, "showConfirmButton") ?? true,
                    isKioskShowed: _.get(options, "isKioskShowed") ?? false
                },
                multiple: true
            };

            if (_.isObject(options)) {
                _.defaults(options, defaultOptions);

                if (options.blocking) {
                    options.clickOutsideToClose = false;
                    options.escapeToClose = false;
                }
            } else {
                options = defaultOptions;
            }

            return $mdDialog.show(options);
        }
    };

    return alertDialog;
}]);
